import React from 'react';
import { Navigate } from 'react-router-dom';

function OldDashboardPriceChangeRequestRedirect() {
    const params = new URLSearchParams(window.location.search);

    return (
        <Navigate
            to={`/price-change/requests${
                params.get('requestId')
                    ? `?requestId=${params.get('requestId')}`
                    : ''
            }`}
            replace
        />
    );
}

export default OldDashboardPriceChangeRequestRedirect;
